/**
 * <ec-collection-tabs> — All collections page (ec-list-collections, grouped).
 *
 * Panels: [data-ec-top="handle"] (one per top menu item), pills:
 * [data-ec-tab="handle"]. Shows the panel named by the URL #hash
 * (case-insensitive, e.g. /collections#summer-collections), else the first,
 * and puts its title ([data-ec-top-title]) in the page banner
 * (.ec-banner__title of ec-page-banner). A pill click updates the hash
 * without jumping; hashchange (a menu link to the same page) switches too.
 */
if (!customElements.get('ec-collection-tabs')) {
  class EcCollectionTabs extends HTMLElement {
    connectedCallback() {
      this.panels = Array.from(this.querySelectorAll('[data-ec-top]'));
      this.tabs = Array.from(this.querySelectorAll('[data-ec-tab]'));
      if (!this.panels.length) return;
      this.bannerTitle = document.querySelector('.ec-banner__title');

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          this.show(tab.dataset.ecTab);
          history.replaceState(null, '', `#${tab.dataset.ecTab}`);
        });
        tab.addEventListener('keydown', (event) => this.onTabKey(event, tab));
      });

      this.onHashChange = () => this.show(this.hashHandle());
      window.addEventListener('hashchange', this.onHashChange);
      this.show(this.hashHandle());
    }

    disconnectedCallback() {
      window.removeEventListener('hashchange', this.onHashChange);
    }

    hashHandle() {
      try {
        return decodeURIComponent(window.location.hash.slice(1)).trim().toLowerCase();
      } catch (error) {
        return window.location.hash.slice(1).trim().toLowerCase();
      }
    }

    show(handle) {
      const panel = this.panels.find((p) => p.dataset.ecTop === handle) || this.panels[0];
      this.panels.forEach((p) => {
        p.hidden = p !== panel;
      });
      this.tabs.forEach((tab) => {
        const active = tab.dataset.ecTab === panel.dataset.ecTop;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
      });
      if (this.bannerTitle) this.bannerTitle.textContent = panel.dataset.ecTopTitle;
      this.classList.add('is-ready');
    }

    // arrow keys move between pills (tablist pattern)
    onTabKey(event, tab) {
      if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
      const index = this.tabs.indexOf(tab);
      const step = event.key === 'ArrowRight' ? 1 : -1;
      const next = this.tabs[(index + step + this.tabs.length) % this.tabs.length];
      next.focus();
      next.click();
    }
  }

  customElements.define('ec-collection-tabs', EcCollectionTabs);
}
